// Navbar.js
import React, { useState, useEffect, useCallback } from 'react';
import { motion } from 'framer-motion';
import { AiOutlineMenu, AiOutlineClose } from 'react-icons/ai';
import enerbyteLogo from '../assets/logos/Enerbyte_logo_med.webp';



const Navbar = () => {
  const [showNavbar, setShowNavbar] = useState(true);
  const [lastScrollY, setLastScrollY] = useState(0);
  const [menuOpen, setMenuOpen] = useState(false);

  /**/
  const sections = [
    { link: 'nosotros', name: 'Sobre Nosotors' },
    { link: 'business', name: 'Servicios' },
    { link: 'contact', name: 'Contactos' },
  ];

  const controlNavbar = useCallback(() => {
    if (window.scrollY > lastScrollY) {
      setShowNavbar(false);
    } else {
      setShowNavbar(true);
    }
    setLastScrollY(window.scrollY);
  }, [lastScrollY]);

  useEffect(() => {
    window.addEventListener('scroll', controlNavbar);
    return () => {
      window.removeEventListener('scroll', controlNavbar);
    };
  }, [controlNavbar]);

  const toggleMenu = () => {
    setMenuOpen((prev) => !prev);
  };

  const handleLinkClick = (href) => {
    setMenuOpen(false);
    if (href !== '#') {
      const target = document.querySelector(href);
      if (target) {
        target.scrollIntoView({ behavior: 'smooth' });
      }
    } else {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  };




  return (
    <motion.nav
      
      initial={{ y: -100 }}
      animate={{ y: showNavbar ? 0 : -100 }}
      transition={{ duration: 0.5 }}
      className=" navbar shadow-md fixed w-full z-10"
    >
      <div className="container mx-auto px-4 py-4 flex justify-between items-center">
        <div
          className="cursor-pointer"
          onClick={() => handleLinkClick('#')}
        >
          <img
            src={enerbyteLogo}
            alt={"EnerByte"}
            className="h-5 w-fullobject-contain grayscale hover:grayscale-0 transition duration-300"
          />
        </div>


        <div className="md:hidden " onClick={toggleMenu}>
          {menuOpen ? <AiOutlineClose className="" /> : <AiOutlineMenu className=''  />}
        </div>

        <ul className={`md:flex space-x-3 items-center ${menuOpen ? 'block' : 'hidden'} md:block absolute md:static top-16 left-0 right- md:bg-transparent p-4 md:p-0`}>
          {sections.map((section, index) => (
            <li
              key={index}
              onClick={() => handleLinkClick(`#${section.link}`)}
              smooth={true}
              duration={500}
              className="px-2 py-2 rounded-md cursor-pointer"
            >
              {section.name}
            </li>
          
          ))}


        </ul>
      
      
      </div>
    </motion.nav>
  );
};

export default Navbar;